<template>
    <v-container>
        <v-row column justify-center align-center>
            <v-col cols="12">
                <v-card class="mx-auto">
                    <v-card-text>
                        <h1 class="text-center">
                            <TranslatableStringComponent
                                :tstring="{ string: 'orderDetails' }"
                            />
                        </h1>
                        <div class="d-flex justify-space-around">
                            <div>
                                <h2>
                                    <TranslatableStringComponent
                                        :tstring="{ string: 'orderSummary' }"
                                    />
                                </h2>
                                <v-skeleton-loader
                                    v-if="!currentOrder"
                                    type="list-item-three-line"
                                    class="mx-auto"
                                ></v-skeleton-loader>
                                <div v-if="currentOrder">
                                    <br />
                                    <div v-if="webOrder && webOrder.docNo">
                                        WEB ORDER #:
                                        <span class="font-weight-bold">{{
                                            webOrder.docNo
                                        }}</span>
                                    </div>
                                    <div v-if="salesOrder && salesOrder.docNo">
                                        SALES ORDER #:
                                        <span class="font-weight-bold">{{
                                            salesOrder.docNo
                                        }}</span>
                                    </div>
                                    <div
                                        v-if="
                                            !salesInvoice &&
                                            shipper &&
                                            shipper.docNo
                                        "
                                    >
                                        SHIPPER #:
                                        <span class="font-weight-bold">{{
                                            shipper.docNo
                                        }}</span>
                                    </div>
                                    <div
                                        v-if="
                                            salesInvoice && salesInvoice.docNo
                                        "
                                    >
                                        INVOICE #:
                                        <span class="font-weight-bold">{{
                                            salesInvoice.docNo
                                        }}</span>
                                    </div>
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'poNo' }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            currentOrder.shippingPoNumber ||
                                            '--------'
                                        }}</span>
                                    </div>
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'orderDate' }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            convertToReadabledate(
                                                currentOrder.transactionDate
                                            )
                                        }}</span>
                                    </div>

                                    <v-divider class="my-2"></v-divider>

                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'shippingAccount',
                                            }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            carrierVendor
                                        }}</span>
                                    </div>
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'shipVia' }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            shipVia
                                        }}</span>
                                    </div>
                                    <div v-show="currentOrder && currentOrder.isShipItComplete">
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'allowBackorders',
                                            }"
                                        />:
                                        <span class="font-weight-bold">No</span>
                                    </div>
                                    <v-divider class="my-2"></v-divider>
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'message' }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            currentOrder.messageFromCustomer ||
                                            '--------'
                                        }}</span>
                                    </div>
                                    <div>
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'status' }"
                                        />:
                                        <span class="font-weight-bold">{{
                                            orderStatus
                                        }}</span>
                                    </div>
                                    <v-btn
                                        v-if="
                                            currentOrder.docType ===
                                            'Sales Invoice'
                                        "
                                        class="mt-2"
                                        small
                                        outlined
                                        color="primary"
                                        @click="$refs.myChild.handleDialog()"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{ string: 'getInvoice' }"
                                        />
                                    </v-btn>
                                </div>
                            </div>
                            <v-divider vertical></v-divider>
                            <div>
                                <h2>
                                    <TranslatableStringComponent
                                        :tstring="{ string: 'billingAddress' }"
                                    />
                                </h2>
                                <v-skeleton-loader
                                    v-if="!billingDetails"
                                    type="list-item-three-line"
                                    class="mx-auto"
                                ></v-skeleton-loader>

                                <br />
                                <div v-if="billingDetails">
                                    <h3>
                                        <!-- {{ billingDetails.firstName }}
                                        {{ billingDetails.lastName }} -->{{
                                            billingDetails.printAs
                                        }}
                                    </h3>
                                    <div>
                                        <!-- {{ billingDetails.company }} -->{{
                                            billingDetails.contactName
                                        }}
                                    </div>
                                    <div>
                                        {{ billingDetails.addressLine1 }}
                                    </div>
                                    <div>
                                        {{ billingDetails.addressLine2 }}
                                    </div>
                                    <div>
                                        {{ billingDetails.city }},
                                        {{ billingDetails.stateProvince }}
                                        {{ billingDetails.zipPostalCode }}
                                        {{ billingDetails.country }}
                                    </div>
                                    <div>
                                        <!-- {{ billingDetails.primaryPhoneNo }} -->
                                    </div>
                                    <div>
                                        {{ billingDetails.primaryEmailAddress }}
                                    </div>
                                </div>
                            </div>
                            <v-divider vertical></v-divider>
                            <div>
                                <h2>
                                    <TranslatableStringComponent
                                        :tstring="{ string: 'shippingAddress' }"
                                    />
                                </h2>
                                <v-skeleton-loader
                                    v-if="!shippingDetails"
                                    type="list-item-three-line"
                                    class="mx-auto"
                                ></v-skeleton-loader>
                                <br />
                                <div v-if="shippingDetails">
                                    <h3>
                                        <!-- {{ shippingDetails.firstName }}
                                        {{ shippingDetails.lastName }} -->{{
                                            shippingDetails.printAs
                                        }}
                                    </h3>
                                    <div>
                                        <!-- {{ shippingDetails.company }} -->{{
                                            shippingDetails.contactName
                                        }}
                                    </div>
                                    <div>
                                        {{ shippingDetails.addressLine1 }}
                                    </div>
                                    <div>
                                        {{ shippingDetails.addressLine2 }}
                                    </div>
                                    <div>
                                        {{ shippingDetails.city }},
                                        {{ shippingDetails.stateProvince }}
                                        {{ shippingDetails.zipPostalCode }}
                                        {{ shippingDetails.country }}
                                    </div>
                                    <div>
                                        <!-- {{ shippingDetails.primaryPhoneNo }} -->
                                    </div>
                                    <div>
                                        {{
                                            shippingDetails.primaryEmailAddress
                                        }}
                                    </div>
                                </div>
                            </div>
                        </div>
                        <v-divider class="mt-10 mb-3"></v-divider>
                        <div v-if="cardFailed">
                            <v-alert text type="error" dense>
                                <TranslatableStringComponent
                                    :tstring="{
                                        string: 'cardDeclineMessage',
                                    }" />
                                <nuxt-link to="contact"
                                    ><TranslatableStringComponent
                                        :tstring="{
                                            string:
                                                'orderHistoryStatusMessageContact',
                                        }" /></nuxt-link
                            ></v-alert>
                        </div>
                        <v-row>
                            <v-col md="8" cols="12">
                                <h2>
                                    <TranslatableStringComponent
                                        :tstring="{ string: 'orderItems' }"
                                    />:
                                </h2>
                                <v-row>
                                    <v-col :cols="isDueDatePresent? '5': '6'" class="font-weight-bold"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'product' }"
                                    /></v-col>
                                    <v-col
                                        v-if="isDueDatePresent"
                                        cols="2"
                                        class="font-weight-bold text-right"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'dueDate' }"
                                    /></v-col>
                                    <v-col
                                        :cols="isDueDatePresent? '1': '2'"
                                        class="font-weight-bold text-right"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'qty' }"
                                    /></v-col>
                                    <v-col
                                        cols="2"
                                        class="font-weight-bold text-right"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'price' }"
                                    /></v-col>
                                    <v-col
                                        cols="2"
                                        class="font-weight-bold text-right"
                                        ><TranslatableStringComponent
                                            :tstring="{ string: 'total' }"
                                    /></v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <div v-if="productLineItems.length === 0">
                                    <v-row v-for="i in 2" :key="i">
                                        <v-col md="3">
                                            <v-skeleton-loader
                                                type="list-item"
                                                class="mx-auto"
                                            ></v-skeleton-loader
                                        ></v-col>
                                        <v-col md="4">
                                            <v-skeleton-loader
                                                type="list-item-three-line"
                                                class="mx-auto"
                                            ></v-skeleton-loader
                                        ></v-col>
                                        <v-col md="1">
                                            <v-skeleton-loader
                                                type="list-item"
                                                class="mx-auto"
                                            ></v-skeleton-loader
                                        ></v-col>
                                        <v-col md="2">
                                            <v-skeleton-loader
                                                type="list-item"
                                                class="mx-auto"
                                            ></v-skeleton-loader
                                        ></v-col>
                                        <v-col md="2">
                                            <v-skeleton-loader
                                                type="list-item"
                                                class="mx-auto"
                                            ></v-skeleton-loader>
                                        </v-col>
                                    </v-row>
                                </div>
                                <v-row
                                    v-for="item in productLineItems"
                                    :key="item.id"
                                >
                                    <v-col :cols="isDueDatePresent? '5': '6'" class="pa-sm-2">
                                        <div class="mb-2 d-flex">
                                            <span class="font-weight-bold">
                                                <TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'partNo',
                                                    }"
                                                />:
                                            </span>
                                            <div
                                                class="product-pn-link ml-1"
                                                @click="
                                                    goToProduct(item.itemName)
                                                "
                                            >
                                                {{
                                                    getPartNumber(item.itemName)
                                                }}
                                            </div>
                                        </div>

                                        <div>
                                            <span class="font-weight-bold">
                                                <TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'partName',
                                                    }"
                                                />:
                                            </span>
                                            <div
                                                class="product-name-link ml-1"
                                                @click="
                                                    goToProduct(item.itemName)
                                                "
                                            >
                                                {{
                                                    getDescription(
                                                        item.itemDescription
                                                    )
                                                }}
                                            </div>
                                        </div>
                                    </v-col>
                                    <v-col v-if="isDueDatePresent" cols="2" class="pa-sm-2 text-right">
                                        <v-chip v-if="isDueDateGreaterThanShippingDate(item)" small label color="#f8e3348c">{{ convertToReadabledate(item.dueDate)}}</v-chip>
                                    </v-col>
                                    <v-col :cols="isDueDatePresent? '1': '2'" class="pa-sm-2 text-right">
                                        {{ item.orderLineQty }}
                                        <v-tooltip
                                            v-if="
                                                item.orderLineQty !==
                                                item.initialItemQuantity
                                            "
                                            bottom
                                        >
                                            <template
                                                v-slot:activator="{ on, attrs }"
                                            >
                                                <fa
                                                    :icon="[
                                                        'fal',
                                                        'info-circle',
                                                    ]"
                                                    class="fa-md"
                                                    style="color: #ffc107"
                                                    v-bind="attrs"
                                                    v-on="on"
                                                />
                                            </template>
                                            <span
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string:
                                                            'originalQuantity',
                                                    }"
                                                />:
                                                {{ item.initialItemQuantity }}
                                                (<TranslatableStringComponent
                                                    :tstring="{
                                                        string:
                                                            'checkOrderHistoryForBackorder',
                                                    }"
                                                />)</span
                                            >
                                        </v-tooltip>
                                    </v-col>
                                    <v-col cols="2" class="pa-sm-2 text-right">
                                        {{ dollars(item.orderLineActualPrice) }}
                                    </v-col>
                                    <v-col
                                        cols="2"
                                        class="pa-sm-2 text-right d-flex flex-column justify-space-between"
                                    >
                                        {{ dollars(item.orderLineTotal) }}
                                        <v-btn
                                            x-small
                                            color="primary"
                                            outlined
                                            @click="reorderItem(item)"
                                            ><TranslatableStringComponent
                                                :tstring="{
                                                    string: 'reOrder',
                                                }"
                                        /></v-btn>
                                    </v-col>
                                    <v-col cols="12"
                                        ><v-divider></v-divider
                                    ></v-col>
                                    <!-- <v-row>
                                        <v-col><v-divider></v-divider></v-col>
                                    </v-row> -->
                                </v-row>
                                <OrderSummaryBackorderAlert
                                    v-if="
                                        backorderItems &&
                                        backorderItems.length > 0
                                    "
                                    :items="backorderItems"
                                    :showItems="showBackOrderItems"
                                    @toggleShowItems="
                                        showBackOrderItems = !showBackOrderItems
                                    "
                                    :boid="finalOrderList[finalOrderListCurrentIndex +1].boid"
                                    :backOrderDocNo="finalOrderList[finalOrderListCurrentIndex +1].backOrderDocNo"
                                    :isBackorder="true"
                                />
                                <OrderSummaryBackorderAlert
                                    v-if="
                                        removedItems &&
                                        removedItems.length > 0
                                    "
                                    :items="removedItems"
                                    :showItems="showRemovedItems"
                                    @toggleShowItems="
                                        showRemovedItems = !showRemovedItems
                                    "
                                />
                            </v-col>
                            <v-col md="4" cols="12">
                                <h2>
                                    <TranslatableStringComponent
                                        :tstring="{ string: 'cartTotals' }"
                                    />:
                                </h2>
                                <v-row>
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{
                                                    string: 'subtotal',
                                                }"
                                            />
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p
                                            v-if="subTotal"
                                            class="text-right mb-0"
                                        >
                                            {{ dollars(subTotal) }}
                                        </p>
                                        <p v-else class="text-right mb-0">
                                            ---.--
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="
                                        couponDetails && couponDiscountValue > 0
                                    "
                                >
                                    <v-col md="6">
                                        <p class="mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{ string: 'coupon' }"
                                            />
                                        </p>
                                        <p class="font-italic mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{ string: 'code' }"
                                            />:
                                            {{
                                                couponDetails.itemIdentifier ||
                                                'N/A'
                                            }}
                                        </p>
                                    </v-col>
                                    <v-col md="6">
                                        <p class="text-right mb-0">
                                            -{{ dollars(couponDiscountValue) }}
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <span
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string: 'shipping',
                                                    }" /></span
                                            ><span v-if="isShippingToBeDecided"
                                                >*</span
                                            >
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p
                                            v-if="shippingLineItem"
                                            class="text-right mb-0"
                                        >
                                            <span v-if="isShippingToBeDecided"
                                                >---</span
                                            >
                                            <span v-else>{{
                                                dollars(
                                                    shippingLineItem.orderLineActualPrice
                                                )
                                            }}</span>
                                        </p>
                                        <p v-else class="text-right mb-0">
                                            ---.--
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row
                                    v-if="
                                        shippingOversizePackageLineItemTotal > 0
                                    "
                                >
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <span
                                                ><TranslatableStringComponent
                                                    :tstring="{
                                                        string:
                                                            'shippingOverSizePackage',
                                                    }"
                                            /></span>
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p class="text-right mb-0">
                                            <span>{{
                                                dollars(
                                                    shippingOversizePackageLineItemTotal
                                                )
                                            }}</span>
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row v-if="handlingFeeTotal > 0">
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{
                                                    string: 'handlingFee',
                                                }"
                                            />
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p class="text-right mb-0">
                                            {{ dollars(handlingFeeTotal) }}
                                        </p>
                                    </v-col>
                                </v-row>

                                <v-row v-if="taxTotal > 0">
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{ string: 'tax' }"
                                            />
                                            <!-- <span v-if="taxRate">
                                                ({{ taxRate }})</span
                                            > -->
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p
                                            v-if="taxTotal"
                                            class="text-right mb-0"
                                        >
                                            {{ dollars(taxTotal) }}
                                        </p>
                                        <p v-else class="text-right mb-0">
                                            ---.--
                                        </p>
                                    </v-col>
                                </v-row>

                                <v-row v-if="tariffAmount">
                                    <v-col md="5">
                                        <p class="mb-0">
                                            <TranslatableStringComponent
                                                :tstring="{ string: 'tariff' }"
                                            />
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p class="text-right mb-0">
                                            {{ dollars(tariffAmount) }}
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-divider></v-divider>
                                <v-row>
                                    <v-col md="5" class="font-weight-bold mb-0">
                                        <p>
                                            <TranslatableStringComponent
                                                :tstring="{
                                                    string: 'orderTotal',
                                                }"
                                            />
                                        </p>
                                    </v-col>
                                    <v-col md="7">
                                        <p
                                            v-if="grandTotal"
                                            class="font-weight-bold text-right mb-0"
                                        >
                                            {{ dollars(grandTotal) }}
                                        </p>
                                        <p v-else class="text-right">---.--</p>
                                    </v-col>
                                </v-row>
                                <v-row v-if="isShippingToBeDecided">
                                    <v-col>
                                        <p
                                            class="font-italic"
                                            style="font-size: 12px"
                                        >
                                            *
                                            <TranslatableStringComponent
                                                :tstring="{
                                                    string: 'shippingTBDNote',
                                                }"
                                            />
                                        </p>
                                    </v-col>
                                </v-row>
                                <div class="reorder-all-button-wrapper">
                                    <v-btn
                                        x-small
                                        color="primary"
                                        outlined
                                        @click="reorderAllItems"
                                    >
                                        <TranslatableStringComponent
                                            :tstring="{
                                                string: 'reOrderAllItems',
                                            }"
                                        />
                                    </v-btn>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
            <v-col v-if="debug" cols="12">
                <pre>{{ currentOrder }}</pre>
            </v-col>
        </v-row>
        <OrderPdfModal
            v-if="currentOrder"
            ref="myChild"
            :order="currentOrder"
        />
        <v-dialog v-model="availabilityDialogBox" persistent width="480">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <TranslatableStringComponent
                        :tstring="{ string: 'itemNotAvailable' }"
                    />
                </v-card-title>
                <v-card-text class="pt-5">
                    <TranslatableStringComponent
                        :tstring="{ string: 'currentlyTheItemIsUnavailable' }"
                    />
                </v-card-text>
                <v-card-actions class="justify-end">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="primary"
                        text
                        @click="availabilityDialogBox = false"
                        >OK</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="showDialogBox" persistent width="480">
            <v-card>
                <v-card-title class="headline grey lighten-2" primary-title>
                    <TranslatableStringComponent
                        :tstring="{ string: 'unavailableItems' }"
                    />
                </v-card-title>
                <v-card-text class="pt-5">
                    <div>
                        <p>
                            <TranslatableStringComponent
                                :tstring="{ string: 'unavailableItemsList' }"
                            />:
                        </p>
                        <ul>
                            <li v-for="(item, i) in unavailableItems" :key="i">
                                {{ item.itemName }}
                            </li>
                        </ul>
                    </div>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        v-if="availableItems.length > 0"
                        color="primary"
                        text
                        @click="proceed()"
                    >
                        <TranslatableStringComponent
                            :tstring="{ string: 'proceedWithAvailableItems' }"
                        />
                    </v-btn>
                    <v-btn color="error" text @click="showDialogBox = false">
                        <TranslatableStringComponent
                            :tstring="{ string: 'cancel' }"
                        />
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-container>
</template>
<script>
import orderSummaryErp from '~/mixins/orderSummaryErp'
import OrderPdfModal from '~/components/OrderPdfModal.vue'
export default {
    name: 'OrderSummary',
    mixins: [orderSummaryErp],
    components: {
        OrderPdfModal,
    },
}
</script>
<style scoped>
.reorder-all-button-wrapper {
    position: absolute;
    right: 24px;
}
.product-pn-link,
.product-name-link {
    color: #0063a6;
    text-decoration: underline;
    cursor: pointer;
}
.product-name-link {
    text-decoration: none;
}
</style>
